import * as React from "react";
import GoogleMapReact, { Props as IMapProps } from "google-map-react";
import { Block } from "../Block";
import { Triangle } from "../Triangle";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TMapBoxProps = {
  outlineColor?: string;
};

const MapBox: React.FC<TMapBoxProps> = ({
  children,
  outlineColor = "mono300",
  ...props
}) => {
  const [, theme] = useStyletron();
  return (
    <Block {...props}>
      <Block display="flex" justifyContent="center">
        <Triangle $color={outlineColor} />
      </Block>
      <Block
        data-chromatic="ignore"
        height="240px"
        overflow="hidden"
        backgroundColor={theme.colors.backgroundPrimary}
        borderRadius="14px"
        borderStyle="solid"
        borderColor={outlineColor}
        borderWidth="5px"
        // border-box for more predicable layout, TODO: implement across front end?
        $style={{
          boxSizing: "border-box",
        }}
      >
        {children}
      </Block>
    </Block>
  );
};

const Map: React.FC<IMapProps> = (mapProps) => {
  const googleMapsApiKey = globalThis.settings.GOOGLE_MAPS_API_KEY;
  return (
    <MapBox>
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleMapsApiKey }}
        defaultCenter={{ lat: -34.397, lng: 150.644 }}
        defaultZoom={14}
        {...mapProps}
      />
    </MapBox>
  );
};

export { MapBox, Map };
